import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import React, { useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'
import { getAttendanceCardTips } from '../utils/tips'

/**
 * 考勤卡片
 *
 * @returns 组件
 */
export const AttendanceCard: React.FC = () => {
  const { semesterInfo, timeRange, role } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentAttendanceStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: attendance } = res || {}

  const attendanceInfo = attendance?.[0]
  return (
    <IndexBoardCard
      title={$t('学生考勤统计')}
      count={attendanceInfo?.students_with_any_inc ?? 0}
      items={[
        {
          label: $t('迟到早退'),
          value: attendanceInfo?.students_with_leave_inc ?? 0,
        },
        {
          label: $t('缺席'),
          value: attendanceInfo?.students_with_absent_inc ?? 0,
        },
      ]}
      flex={1}
      type={StatsDetailsTabEnum.StudentAttendance}
      loading={loading}
      tips={getAttendanceCardTips(role)}
      itemIconMsg={{
        name: 'CalendarCheck',
        color: '#FF7D00',
        backgroundColor: '#FFF8E8',
      }}
    />
  )
}
